import React, { useContext, useMemo } from 'react';
import { AggregatorClient } from '../../common/clients';
import { useExperiments } from '../../common/experiment-provider';

// Scope is a string, Filters must be extended from FilterInterface

var AggregatorClientContext = /*#__PURE__*/React.createContext(undefined);
export var AggregatorClientContextProvider = function AggregatorClientContextProvider(_ref) {
  var abTestCloudId = _ref.abTestCloudId,
    aggregatorUrl = _ref.aggregatorUrl,
    children = _ref.children;
  var _useExperiments = useExperiments(),
    backendExperiment = _useExperiments.backendExperiment;
  var aggregatorClient = useMemo(function () {
    return new AggregatorClient({
      url: aggregatorUrl,
      cloudId: abTestCloudId,
      siteMasterList: [],
      backendExperiment: backendExperiment
    });
  }, [abTestCloudId, aggregatorUrl, backendExperiment]);
  return /*#__PURE__*/React.createElement(AggregatorClientContext.Provider, {
    value: aggregatorClient
  }, children);
};

/**
 * Returns a generic Aggregator client with no typing
 * @deprecated use {@link useTypedAggregatorClient} instead
 */
export var useAggregatorClient = function useAggregatorClient() {
  var aggregatorClient = useContext(AggregatorClientContext);
  return aggregatorClient;
};

/**
 * Fetch an Aggregator client from the context.
 * @typeParam Response the client's response type
 * @typeParam Scope the client's scope type
 * @returns an {@link AggregatorClient}
 */
export var useTypedAggregatorClient = function useTypedAggregatorClient() {
  // Casting done here to ensure that the result types match the scopes requested
  var untypedClient = useContext(AggregatorClientContext);
  return untypedClient;
};